import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ colors, border, font, spacing }) => ({
  container: {
    flexDirection: "row",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    backgroundColor: colors.backgroundDefault,
    borderWidth: border.widths.md,
    borderColor: colors.borderDefault,
    borderRadius: border.radius.md,
    outlineWidth: spacing(0.5),
    outlineColor: "transparent",
    outlineOffset: spacing(1),
    paddingHorizontal: spacing(4),
    _web: {
      "_focus-within": {
        outlineStyle: "solid",
        outlineColor: colors.borderFocus,
      },
    },
    variants: {
      isRounded: {
        true: {
          borderRadius: border.radius.full,
        },
      },
    },
  },
  input: {
    flex: 1,
    paddingVertical: spacing(4),
    color: colors.foregroundDefault,
    borderRadius: border.radius.sm,
    fontFamily: font.families.body,
    fontSize: font.sizes.body,
    variants: {
      isRounded: {
        true: {
          borderRadius: border.radius.full,
        },
      },
      withIcon: {
        true: {
          paddingLeft: spacing(4),
        },
      },
    },
    _web: {
      _focus: {
        outline: "none",
      },
    },
  },
  inputPlaceholder: {
    color: colors.foregroundDefaultMuted,
  },
  icon: {
    width: spacing(7),
    height: spacing(7),
    color: colors.foregroundDefault,
  },
}));

export default stylesheet;
